import React from 'react';
import { Sparkles } from 'lucide-react';
import './AIFloatingButton.css';

interface AIFloatingButtonProps {
    onClick: () => void;
    isOpen?: boolean;
    unreadCount?: number;
}

export const AIFloatingButton: React.FC<AIFloatingButtonProps> = ({
    onClick,
    isOpen = false,
    unreadCount = 0,
}) => {
    return (
        <button
            type="button"
            className={`ai-floating-btn ${isOpen ? 'active' : ''}`}
            onClick={onClick}
            title="Asistente IA"
            aria-label="Abrir chat de Asistente IA"
        >
            <div className="ai-floating-btn__icon-wrapper">
                <Sparkles className="ai-floating-btn__icon" size={24} />
            </div>
            {unreadCount > 0 && (
                <span className="ai-floating-btn__badge">{unreadCount}</span>
            )}
        </button>
    );
};
